<template>
  <el-row id="loginMenu">
    <el-col :span="12">
      <rememberPwd :form-obj.sync="formObj" />
    </el-col>
    <el-col :span="12" style="text-align: right">
      <router-link :to="{name:'forgot'}">
        <el-button type="text">{{$t("cmsg.forgot")}}</el-button>
      </router-link>
    </el-col>
  </el-row>
</template>

<script>
import rememberPwd from "./rememberPwd.vue";
export default {
  name: "login-menu",
  components: {
    rememberPwd
  },
  props: {
      formObj: {
          type: Object,
          default: {}
      }
  },
  data() {
    return {};
  },
  methods: {
    regNow(routeName) {
      console.log(routeName);
      // windows.location=this.$router.resolve({name: routeName}).href;
      this.$redirect({ name: routeName });
    }
  }
};
</script>
<style lang="scss">
#loginMenu {
  line-height: 50px;
  .el-col {
    .el-dropdown {
      span.el-dropdown-selfdefine {
        cursor: pointer;
      }
    }
  }
}
</style>
